import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_white.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3add08fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "logo"
}
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = {
  key: 2,
  class: "text"
}

import { getCurrentDomain } from "@/services/utils/Domain";


export default /*#__PURE__*/_defineComponent({
  __name: 'DvLogoComponent',
  setup(__props) {

const domain = getCurrentDomain();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(domain).includes('dvgroup.com'))
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_unref(domain).includes('cvdashboard.ru'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " CooperVision "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "CDP"))
  ]))
}
}

})